export default __webpack_public_path__ + "static/media/typewriterRewardImg.dc9be478.png";